import { render } from "./Channels.vue?vue&type=template&id=69fc918d&scoped=true&ts=true"
import script from "./Channels.vue?vue&type=script&lang=ts"
export * from "./Channels.vue?vue&type=script&lang=ts"

import "./Channels.vue?vue&type=style&index=0&id=69fc918d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fc918d"]])

export default __exports__